module.exports = __webpack_public_path__ + "img/SYMM_PbQ_blk-Horizontal-Logo.16c648a0.svg";